import React from "react";
import * as Icons from "lucide-react";
import { SERVICES, WHY, IMAGES } from "../../mock";
import Reveal from "./Reveal";

export const Badge = ({ children }) => (
  <span className="inline-block rounded-full border border-brand/35 bg-brand/10 px-4 py-1 text-[12px] font-semibold uppercase tracking-[0.08em] text-brand">{children}</span>
);

export const SectionHead = ({ badge, title, sub }) => (
  <Reveal className="mx-auto mb-14 max-w-[720px] text-center">
    <Badge>{badge}</Badge>
    <h2 className="mt-5 font-display text-[40px] font-bold leading-tight text-white sm:text-[48px]">{title}</h2>
    <p className="mt-3 text-lg text-white/55">{sub}</p>
  </Reveal>
);

export const Services = () => (
  <section id="services" className="bg-[#08090b] py-24 lg:py-28">
    <div className="container-x">
      <SectionHead badge="What We Do" title="Performance, Reimagined" sub="Specialist tuning and diagnostics built around how you really drive." />
      <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((s, i) => {
          const Icon = Icons[s.icon];
          return (
            <Reveal key={s.title} delay={i * 80}>
              <div className="card-hover group h-full rounded-2xl border border-white/10 bg-[#111217] p-6 sm:p-7" data-testid={`service-card-${i}`}>
                <div className="flex h-12 w-12 items-center justify-center rounded-full border border-brand/25 bg-brand/10 text-brand transition-colors group-hover:bg-brand group-hover:text-white">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="mt-8 font-display text-[22px] font-bold text-white">{s.title}</h3>
                <p className="mt-3 text-[14.5px] leading-relaxed text-white/55">{s.desc}</p>
                <ul className="mt-5 space-y-2">
                  {s.points.map((p) => (
                    <li key={p} className="flex items-center gap-3 text-[14.5px] text-white/85"><span className="h-1.5 w-1.5 rounded-full bg-brand" />{p}</li>
                  ))}
                </ul>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);

export const WhyUs = () => (
  <section id="why" className="relative overflow-hidden bg-[#0d0e12] py-24 lg:py-28">
    <div className="container-x grid items-center gap-14 lg:grid-cols-2">
      <Reveal className="relative">
        <div className="absolute -inset-8 rounded-3xl bg-brand/10 blur-3xl" />
        <div className="relative overflow-hidden rounded-2xl border border-white/10">
          <img src={IMAGES.tech} alt="Technician working on a vehicle" className="h-[520px] w-full object-cover transition-transform duration-700 hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
        </div>
        <div className="absolute -bottom-6 right-4 rounded-xl border border-white/10 bg-[#111217] px-6 py-4 shadow-2xl sm:right-[-20px]">
          <div className="font-display text-3xl font-bold text-brand">NW London</div>
          <div className="text-sm text-white/60">Mobile & workshop service</div>
        </div>
      </Reveal>
      <div>
        <Reveal>
          <Badge>Why EvtTuning</Badge>
          <h2 className="mt-5 font-display text-[40px] font-bold leading-[1.05] text-white sm:text-[48px]">Tailored Tuning<br /><span className="italic text-brand">For Your Vehicle</span></h2>
          <p className="mt-6 text-lg leading-relaxed text-white/55">Hands-on experience, professional diagnostic tools and carefully developed software come together to give you a smoother drive and real performance gains.</p>
        </Reveal>
        <div className="mt-10 grid gap-4 sm:grid-cols-2">
          {WHY.map((w, i) => {
            const Icon = Icons[w.icon];
            return (
              <Reveal key={w.title} delay={i * 90}>
                <div className="card-hover h-full rounded-xl border border-white/10 bg-[#111217] p-5" data-testid={`why-card-${i}`}>
                  <Icon className="h-6 w-6 text-brand" />
                  <h3 className="mt-5 text-[17px] font-semibold text-white">{w.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-white/55">{w.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </div>
  </section>
);
